// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumEnvironmentOperationStatus = {
  EnvOpPending: 'PENDING',
  EnvOpRunning: 'RUNNING',
  EnvOpSucceeded: 'SUCCEEDED',
  EnvOpFailed: 'FAILED',
  EnvOpCancelled: 'CANCELLED',
} as const;
export type EnumEnvironmentOperationStatus =
  (typeof EnumEnvironmentOperationStatus)[keyof typeof EnumEnvironmentOperationStatus];

export function instanceOfEnumEnvironmentOperationStatus(value: any): boolean {
  for (const key in EnumEnvironmentOperationStatus) {
    if (
      Object.prototype.hasOwnProperty.call(EnumEnvironmentOperationStatus, key)
    ) {
      if (
        EnumEnvironmentOperationStatus[
          key as keyof typeof EnumEnvironmentOperationStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EnumEnvironmentOperationStatusFromJSON(
  json: any,
): EnumEnvironmentOperationStatus {
  return EnumEnvironmentOperationStatusFromJSONTyped(json, false);
}

export function EnumEnvironmentOperationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentOperationStatus {
  return json as EnumEnvironmentOperationStatus;
}

export function EnumEnvironmentOperationStatusToJSON(
  value?: EnumEnvironmentOperationStatus | null,
): any {
  return value as any;
}

export function EnumEnvironmentOperationStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentOperationStatus {
  return value as EnumEnvironmentOperationStatus;
}
